import $ from 'jquery';

$(function() {
  $('.faq-section').css('display', 'none');
  $('.faq-section').first().css('display', 'block');

  $('.faq-item-btn').first().addClass('active-faq-item-btn').find('svg').css('fill', '#FF5733');

  $('.faq-item-btn').on('click', function(e) {
    e.preventDefault();
    $('.faq-item-btn').removeClass('active-faq-item-btn').find('svg').css('fill', '');
    $(this).addClass('active-faq-item-btn').find('svg').css('fill', '#FF5733');
    const target = $(this).attr('href');
    const targetID = target.replace(/^#/, '');
    $('.faq-section').css('display', 'none');
    $('#' + targetID).css('display', 'block');
    $('html, body').animate({
      scrollTop: $('#' + targetID).offset().top - 125
    }, 500);
  });

  $('.FaqItem__content').hide();

  $('.FaqItem__button').on('click', function(e) {
    e.preventDefault();
    const $parent = $(this).closest('.FaqItem');
    $parent.toggleClass('FaqItem--active');
    $parent.find('.FaqItem__content').slideToggle();
    $parent.siblings('.FaqItem').removeClass('FaqItem--active').find('.FaqItem__content').slideUp();
  });
});
